export default __webpack_public_path__ + "static/media/d7a32c8c7da150d8.74a5567e7b998bd560c983209bd6fe65.svg";